// extracted by mini-css-extract-plugin
export default {"grid":"UserGroupPrivilegesGrid_grid__dK0Xy"};